export default __webpack_public_path__ + "images/P7.4be5888.png";